import type { RouteObject } from 'react-router-dom'

const overtimeRoute: RouteObject = {
  children: [
    {
      children: [
        { lazy: () => import('@/pages/overtime/overtime-management/index/page'), path: '' },
        { lazy: () => import('@/pages/overtime/overtime-management/create/page'), path: 'create' },
      ],
      path: 'overtime-management',
    },
    {
      path: 'overtime-policy',
      children: [
        { lazy: () => import('@/pages/overtime/overtime-policy/index/page'), path: '' },
        { lazy: () => import('@/pages/overtime/overtime-policy/create/page'), path: 'create' },
        { lazy: () => import('@/pages/overtime/overtime-policy/edit/page'), path: ':overtimePolicyId' },
      ],
    },
  ],
  path: 'overtime',
}

export default overtimeRoute
